import {
    addDoc,
    getDocs,
    collection,
    doc,
    updateDoc
} from 'firebase/firestore'
import { db } from '../firebase'
export default class Category {
    constructor() {
        this.KEY = 'Category'
    }
    async allCategories() {
        let data = []
        try {
            const querySnapshot = await getDocs(collection(db, this.KEY));

            querySnapshot.forEach((doc) => {
                data.push({ ...doc.data(), id: doc.id })
            });
            return data
        } catch (error) {
            console.log(error);
            return []
        }
    }
    async addCategory(params) {
        try {
            if (params.id) {
                const { id, ...prms } = params
                const docRef = doc(db, this.KEY, id)
                return await updateDoc(docRef, prms)
            }
            return await (await addDoc(collection(db, this.KEY), params)).id
        } catch (error) {
            console.error(error, params);
        }
    }
}